var _rect, _path, _rect2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatsList({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 24.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#2F68E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.745 47.5C20.745 48.1931 21.3069 48.755 22 48.755C22.6931 48.755 23.255 48.1931 23.255 47.5L20.745 47.5ZM22.8874 32.6126C22.3973 32.1225 21.6027 32.1225 21.1126 32.6126L13.1259 40.5993C12.6358 41.0894 12.6358 41.884 13.1259 42.3741C13.616 42.8642 14.4106 42.8642 14.9007 42.3741L22 35.2748L29.0993 42.3741C29.5894 42.8642 30.384 42.8642 30.8741 42.3741C31.3642 41.884 31.3642 41.0894 30.8741 40.5993L22.8874 32.6126ZM23.255 47.5L23.255 33.5L20.745 33.5L20.745 47.5L23.255 47.5Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 24.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#93B5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.255 33.5C59.255 32.8069 58.6931 32.245 58 32.245C57.3069 32.245 56.745 32.8069 56.745 33.5L59.255 33.5ZM57.1126 48.3874C57.6027 48.8775 58.3973 48.8775 58.8874 48.3874L66.8741 40.4007C67.3642 39.9106 67.3642 39.116 66.8741 38.6259C66.384 38.1358 65.5894 38.1358 65.0993 38.6259L58 45.7252L50.9007 38.6259C50.4106 38.1358 49.616 38.1358 49.1259 38.6259C48.6358 39.116 48.6358 39.9106 49.1259 40.4007L57.1126 48.3874ZM56.745 33.5L56.745 47.5L59.255 47.5L59.255 33.5L56.745 33.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsList);
export default __webpack_public_path__ + "static/media/stats-list.a3ccd14001f0c31982bd9296c3ce8f21.svg";
export { ForwardRef as ReactComponent };